export const isMobile = () => window.matchMedia('(max-width: 576px)').matches;

export const isTasksCompact = () => window.matchMedia('(max-width: 1024px)').matches;
